import i18next from 'i18next';

import en from './navigation-i18n/en';
import it from './navigation-i18n/it';

import { type NavigationItem } from 'app/store/fuse/navigationSlice';

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const navigationConfig: NavigationItem[] = [
	{
		id: 'dashboards',
		title: 'Dashboards',
		translate: 'DASHBOARDS',
		auth: 'superuser',
		type: 'group',
		icon: 'bar-chart',
		children: [
			{
				id: 'dashboard_user',
				title: 'User Dashboard',
				translate: 'DASHBOARD_USER',
				auth: 'superuser',
				type: 'item',
				icon: 'home-analytics',
				url: 'summary'
			}
			// {
			// 	id: 'kpis',
			// 	title: 'KPIs',
			// 	translate: 'DASHBOARD_KPIS',
			// 	auth: ['admin'],
			// 	type: 'item',
			// 	icon: 'performance',
			// 	url: 'kpis/goals'
			// }
			// {
			// 	id: 'powerbi_stats',
			// 	title: 'PowerBI stats',
			// 	translate: 'DASHBOARD_POWERBI_STATS',
			// 	auth: 'superuser',
			// 	type: 'item',
			// 	icon: 'file-chart',
			// 	url: 'powerbi-stats'
			// }
		]
	},
	// {
	// 	id: 'company-info',
	// 	title: 'Company Info',
	// 	translate: 'COMPANY_INFO',
	// 	auth: 'superuser',
	// 	type: 'group',
	// 	icon: 'office-building',
	// 	children: [
	// 		{
	// 			id: 'organization-chart',
	// 			title: 'Organization Chart',
	// 			translate: 'ORGANIZATION_CHART',
	// 			auth: 'superuser',
	// 			type: 'item',
	// 			icon: 'family-tree',
	// 			url: 'organization-chart'
	// 		}
	// 	]
	// },
	{
		id: 'communications_management',
		title: 'Communications Management',
		translate: 'COMMUNICATIONS_MANAGEMENT',
		auth: 'superuser',
		type: 'group',
		icon: 'announcements',
		children: [
			{
				id: 'communications',
				title: 'Communications',
				translate: 'COMMUNICATIONS',
				auth: 'superuser',
				type: 'item',
				icon: 'newspaper-variant',
				url: 'communications/list'
			},
			{
				id: 'requests',
				title: 'Requests',
				translate: 'REQUESTS',
				auth: 'superuser',
				type: 'item',
				icon: 'account-voice',
				url: 'requests/list'
			},
			{
				id: 'leave',
				title: 'Leave',
				translate: 'LEAVE',
				auth: 'superuser',
				type: 'item',
				icon: 'luggage',
				url: 'leave/list'
			}
			// {
			// 	id: 'powerbi_stats',
			// 	title: 'PowerBI stats',
			// 	translate: 'DASHBOARD_POWERBI_STATS',
			// 	auth: 'superuser',
			// 	type: 'item',
			// 	icon: 'file-chart',
			// 	url: 'powerbi-stats'
			// }
		]
	},
	// {
	// 	id: 'training',
	// 	title: 'Training',
	// 	translate: 'TRAINING',
	// 	auth: 'superuser',
	// 	type: 'group',
	// 	icon: 'head-lightbulb-outline',
	// 	children: [
	// 		{
	// 			id: 'skills',
	// 			title: 'Skills',
	// 			translate: 'SKILLS',
	// 			auth: 'superuser',
	// 			type: 'item',
	// 			icon: 'book',
	// 			url: 'skills/list'
	// 		},
	// 		{
	// 			id: 'courses',
	// 			title: 'Courses',
	// 			translate: 'COURSES',
	// 			auth: 'superuser',
	// 			type: 'item',
	// 			icon: 'school',
	// 			url: 'courses/list'
	// 		}
	// 	]
	// },
	{
		id: 'registries',
		title: 'Registries',
		translate: 'REGISTRIES',
		auth: 'superuser',
		type: 'group',
		icon: 'format-list-bulleted-square',
		children: [
			{
				id: 'mails',
				title: 'E-mails',
				translate: 'MAILS',
				auth: 'superuser',
				type: 'item',
				icon: 'email',
				url: 'mails/list'
			},
			{
				id: 'phones',
				title: 'Phone Numbers',
				translate: 'PHONENUMBERS',
				auth: 'superuser',
				type: 'item',
				icon: 'phone',
				url: 'phones/list'
			},
			{
				id: 'socialnetworks',
				title: 'Social Networks',
				translate: 'SOCIALNETWORKS',
				auth: 'superuser',
				type: 'item',
				icon: 'web',
				url: 'socialnetworks/list'
			}
		]
	},
	{
		id: 'system',
		title: 'System',
		translate: 'SYSTEM',
		auth: 'superuser',
		type: 'group',
		icon: 'cog',
		children: [
			{
				id: 'documents-folders',
				title: 'Documents Folders',
				translate: 'DOCUMENTS_FOLDERS',
				auth: 'superuser',
				type: 'item',
				icon: 'folder-multiple',
				url: 'sys/documents/folders/list'
			},
			{
				id: 'users',
				title: 'Users',
				translate: 'USERS',
				auth: 'superuser',
				type: 'item',
				icon: 'account-circle',
				url: 'users/list'
			},
			{
				id: 'groups',
				title: 'Groups',
				translate: 'GROUPS',
				auth: 'superuser',
				type: 'item',
				icon: 'account-group',
				url: 'groups/list'
			},
			{
				id: 'tags',
				title: 'Tags',
				translate: 'TAGS',
				auth: 'superuser',
				type: 'item',
				icon: 'hashtag',
				url: 'tags/list'
			},
			{
				id: 'trash_can',
				title: 'Recycle Bin',
				translate: 'RECYCLE_BIN',
				auth: ['superuser', 'admin'],
				type: 'item',
				icon: 'trash-can-outline',
				url: 'recycle-bin'
			},
			{
				id: 'logs',
				title: 'Logs',
				translate: 'LOGS',
				auth: 'admin',
				type: 'item',
				icon: 'timetable',
				url: 'logs'
			},
			{
				id: 'system_tables',
				title: 'System tables',
				translate: 'SYSTEM_TABLES',
				auth: 'admin',
				type: 'item',
				icon: 'remote-desktop',
				url: 'systemtables'
			},
			{
				id: 'permissions_management',
				title: 'Permissions Management',
				translate: 'PERMISSIONS_MANAGEMENT',
				auth: 'dev',
				type: 'item',
				icon: 'shield-lock',
				url: 'permissions-management'
			},
			{
				id: 'settings',
				title: 'Settings',
				translate: 'SETTINGS',
				auth: 'admin',
				type: 'item',
				icon: 'cog',
				url: 'settings'
			}
		]
	}
];

export default navigationConfig;
